import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

export interface EAApiErrorPanelProps {
  title: string;
  message?: string | null;
  detail?: string | null;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export const EAApiErrorPanel: React.FC<EAApiErrorPanelProps> = ({
  title,
  message,
  detail,
  onRetry,
  retryLabel = 'Retry',
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}>
    <div className="w-14 h-14 rounded-full bg-rose-50 border border-rose-100 flex items-center justify-center mb-4">
      <AlertTriangle className="w-7 h-7 text-rose-500" />
    </div>
    <p className="text-base font-semibold text-[#18365E] mb-1">{title}</p>
    {message && (
      <p className="text-sm text-[#717182] max-w-md leading-relaxed">{message}</p>
    )}
    {detail && (
      <p className="mt-3 text-xs text-[#a0a0b0] font-mono bg-[#F5F7FA] border border-[#e5e7eb] rounded px-3 py-1.5 max-w-lg break-all">
        {detail}
      </p>
    )}
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="mt-5 inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-[#18365E] rounded-lg hover:bg-[#18365E]/90 transition-colors"
      >
        <RotateCcw className="w-4 h-4" />
        {retryLabel}
      </button>
    )}
  </div>
);

export default EAApiErrorPanel;
